export const DocumentTypeConstant = {
    riskDocument: 'RiskDocument',
    riskBindDocument:'RiskBindDocument',
    riskUWApprovalDocument: 'RiskUWApprovalDocument',
    ftpDocument: 'FTPDocument',
    ftpocumentTemporary: 'FTPDocumentTemporary',
    otherDocument: 'OtherDocument'
};